module.exports = __webpack_public_path__ + "img/helle-koepfe-logo.58acb55f.svg";